import { useEffect } from 'react';

/**
 * Hook to prevent body scrolling when modal is open
 * @param isOpen - Whether the modal is currently open
 */
export function useBodyScrollLock(isOpen: boolean) {
  useEffect(() => {
    if (isOpen) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [isOpen]);
}
